/**
 * Generato automaticamente.
 * framework-cmp-domande
 */

export type EnumTipoMittenteDTOCodice =
  (typeof EnumTipoMittenteDTOCodice)[keyof typeof EnumTipoMittenteDTOCodice];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnumTipoMittenteDTOCodice = {
  RICHIEDENTE: 'RICHIEDENTE',
  TITOLARE: 'TITOLARE',
  RESPONSABILE_PROCEDIMENTO: 'RESPONSABILE_PROCEDIMENTO',
  ENDOPROCEDIMENTI_PRIMO_LIVELLO: 'ENDOPROCEDIMENTI_PRIMO_LIVELLO',
  ALTRO_UFFICIO_VARIABILE: 'ALTRO_UFFICIO_VARIABILE',
  SISTEMA: 'SISTEMA',
} as const;
